import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import Select from "src/components/Select";
import Radio from "src/components/Radio";
import {
  getNationalities,
  getEthnicities,
  getCountries,
} from "src/models/fields";
import { setDefaultValues } from "src/utils";

const defaultValues = {
  NationalityID: "GB",
  CountryID: "XF",
  EthnicGroupID: "31",
  EuroResidentID: "",
  CriminalConvictionID: "",
};

const EqualOpportunities = ({ data, onSubmit }) => {
  // Data loading
  const nationalities = useQuery("nationalities", getNationalities);
  const ethnicities = useQuery("ethnicities", getEthnicities);
  const countries = useQuery("countries", getCountries);

  // Form
  const { control, register, handleSubmit, formState } = useForm({
    mode: "all",
    defaultValues: setDefaultValues(defaultValues, data),
  });
  const { errors, isSubmitting } = formState;

  return (
    <>
      <h2>Equal Opportunities</h2>

      <p>
        South Central Institute of Technology is an equal opportunities
        provider. For the equal opportunities policy to be effective, it is
        necessary to monitor all applications. Answering the questions below
        will not influence your eligibility for one of our training programmes.
      </p>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12 col-md-6">
            <Select
              label="Nationality (as on passport)"
              name="NationalityID"
              control={control}
              isLoading={nationalities.isLoading}
              options={nationalities.data}
              placeholder="Please select a nationality"
              validation={{ required: "This field is required" }}
              error={errors.NationalityID}
            />
          </div>
          <div className="col-12 col-md-6">
            <Select
              label="Ethnicity"
              name="EthnicGroupID"
              control={control}
              isLoading={ethnicities.isLoading}
              options={ethnicities.data}
              placeholder="Please select an ethnicity"
              validation={{ required: "This field is required" }}
              error={errors.EthnicGroupID}
            />
          </div>

          <div className="col-12 col-md-6">
            <Select
              label="Country of Residence"
              name="CountryID"
              control={control}
              isLoading={countries.isLoading}
              options={countries.data}
              validation={{ required: "This field is required" }}
              error={errors.CountryID}
            />
          </div>

          <div className="col-12 col-md-6">
            <Radio
              label="Are you a UK national who has been resident in the UK for the last 3 years?"
              name="EuroResidentID"
              options={[
                { label: "Yes", value: "1" },
                { label: "No", value: "0" },
              ]}
              inline
              register={register}
              validation={{ required: "This field is required" }}
              error={errors.EuroResidentID}
            />
          </div>
        </div>

        <h2>Criminal Convictions</h2>

        <Radio
          label="Do you have any relevant unspent criminal conviction?"
          name="CriminalConvictionID"
          options={[
            { label: "Yes", value: "2" },
            { label: "No", value: "3" },
          ]}
          inline
          register={register}
          validation={{ required: "This field is required" }}
          error={errors.CriminalConvictionID}
        />

        <div className="form-info-box">
          <p>
            If you declare that you have a relevant conviction, you will be
            contacted by a College manager to discuss your conviction further
            and possibly arrange a meeting to discuss your application. If you
            would like advice on whether your conviction is unspent, please
            contact NACRO on 0300 123 1999.
          </p>
        </div>

        <button type="submit" className="form-submit" disabled={isSubmitting}>
          {isSubmitting ? "Saving" : "Next"}
        </button>
      </form>
    </>
  );
};

export default EqualOpportunities;
